<template>
  <el-dialog :title="$t('19')" :close-on-click-modal="false" :visible.sync="visible" append-to-body>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-form-item :label="$t('783')" prop="department_id">
        <el-popover v-model="popover" ref="orgPopover" placement="bottom-start" trigger="click">
          <dep-tree v-if="popover" @node-click="handleNodeClick"></dep-tree>
        </el-popover>
        <el-input
          v-model="dataForm.department_name"
          v-popover:orgPopover
          :readonly="true"
          :placeholder="$t('785')"
        ></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" plain @click="dataFormSubmit" :disabled="disabled">
        {{ $t('131') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { updateStaffDepartmentFn } from 'api/org/dep'
import depTree from '@/components/dep-tree'

export default {
  components: {
    depTree
  },
  data() {
    return {
      visible: false,
      disabled: false,
      dataForm: {
        department_id: '',
        department_name: '',
        staff_ids: []
      },
      dataRule: {
        department_id: [
          {
            required: true,
            message: this.$t('794')
          }
        ]
      },
      popover: false
    }
  },
  methods: {
    init(staffIds) {
      this.visible = true
      this.dataForm.staff_ids = staffIds
    },
    handleNodeClick(val) {
      this.dataForm = Object.assign(this.dataForm, val)
      this.popover = false
    },
    dataFormSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.disabled = true
          updateStaffDepartmentFn(this.dataForm).then(res => {
            this.disabled = false
            if (res && res.code === 1) {
              this.visible = false
              this.$parent.isDepAdjust && (this.$parent.isDepAdjust = false)
              this.$emit('refreshDataList')
              this.$message({
                type: 'success',
                message: this.$t('777')
              })
            }
          })
        }
      })
    }
  }
}
</script>
